import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/auth/admin`;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
const [schoolDetails, setSchoolDetails] = useState(null);
useEffect(() => {
  axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/school/getSchool`)
    .then((res) => {
      if (res.data) {
        setSchoolDetails(Array.isArray(res.data) ? res.data[0] : res.data);
      }
    })
    .catch(() => {});
}, []);

  // Fetch sessions from backend
  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/sessions/allSessions`);
        setSessions(res.data);
      } catch (err) {
        console.error('Error fetching sessions:', err);
        setError('Failed to fetch sessions');
      }
    };
    fetchSessions();
  }, []);

  const handleLogin = async (e) => {
  e.preventDefault();
  setError('');
  setLoading(true);

  if (!username || !password) {
    setError('Please enter username and password');
    setLoading(false);
    return;
  }

  try {
    const payload = { username, password };
    if (selectedSession) payload.sessionId = selectedSession;

    const { data } = await axios.post(`${API_BASE}/login`, payload);

    localStorage.setItem('token', data.token);
    localStorage.setItem('userId', data.user._id);
    localStorage.setItem('TeacheruserId', data.user.userId || '');
    localStorage.setItem('username', data.user.username);
    localStorage.setItem('usertype', data.user.usertype);
    localStorage.setItem('designation', data.user.designation || 'ADMIN');
    localStorage.setItem(
      'permissions',
      JSON.stringify(data.user.permissions || {})
    );

    // ✅ SESSION FROM BACKEND
    if (data.session) {
      localStorage.setItem('currentSessionId', data.session._id);
      localStorage.setItem('currentSessionName', data.session.sessionName);
    }

    window.dispatchEvent(new Event('storage'));
    navigate('/', { replace: true });

  } catch (err) {
    setError(err.response?.data?.message || 'Invalid username or password');
    console.error('Login error:', err);
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="flex h-screen">
      {/* Left Section */}
      <div className="hidden md:flex w-1/2 bg-gradient-to-br from-blue-600 to-blue-900 justify-center items-center">
        <div className="text-center text-white p-8">
          <div className="flex justify-center mb-6">
  <img
    src="/assets/gurukulerpogin.png"
    alt="Gurukul Logo"
    className="h-[20vh] w-auto object-contain"
  />
</div>
          <h1 className="text-5xl font-bold mb-4">Welcome to Gurukul</h1>
          <p className="text-lg">Your journey to knowledge and excellence begins here.</p>
        </div>
      </div>

      {/* Right Section - Login Form */}
      <div className="flex w-full md:w-1/2 justify-center items-center bg-white">
      
        <div className="w-full max-w-md p-8">
          {/* SCHOOL LOGO */}
    {schoolDetails?.logo && (
      <div className="flex justify-center mb-6">
        <img
          src={schoolDetails.logo}
          alt="School Logo"
          className="h-28 w-auto object-contain"
        />
      </div>
    )}

          <h2 className="text-3xl font-bold mb-6 text-gray-800 text-center">Login</h2>

          {error && <p className="text-red-500 text-center mb-4">{error}</p>}

          <form onSubmit={handleLogin} className="space-y-4">
            {/* Username */}
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-700">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your username"
              />
            </div>

            {/* Password */}
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your password"
              />
            </div>

            {/* Session Selection */}
            <div>
              <label htmlFor="session" className="block text-sm font-medium text-gray-700">Select Session</label>
              <select
                id="session"
                value={selectedSession}
                onChange={(e) => setSelectedSession(e.target.value)}
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Select Session</option>
                {sessions.map(s => (
                  <option key={s._id} value={s._id}>
                    {s.sessionName}
                  </option>
                ))}
              </select>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full py-2 px-4 bg-blue-600 text-white font-bold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            >
              {loading ? (
                <div className="flex justify-center">
                  <div className="w-4 h-4 border-2 border-t-transparent border-white rounded-full animate-spin"></div>
                </div>
              ) : 'Log In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
